export enum PlanUsageCategory {
    SEND_TEXT = 'SEND_TEXT',
    RECHARGE = 'RECHARGE',
    SEND_TEXT_FAILED_READJUSTMENT  = 'SEND_TEXT_FAILED_READJUSTMENT'
}